export default __webpack_public_path__ + "static/media/search.55cf05fd.svg";